import { useEffect, useState } from 'react';
import {
	Container,
	Grid,
	Paper,
	Typography,
	Box,
	useTheme,
	useMediaQuery,
	IconButton,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogContentText,
	DialogActions,
	Button
} from '@mui/material';
import { Delete } from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import Page from '../components/Page';
import { useSelector } from 'react-redux';
import { getCardData, deleteCardData } from '../features/debit/debitSlice';
import { store, RootState } from '../store';
import { Link } from 'react-router-dom';
import { authed } from '../features/login/loginSlice';
import LoginButton from '../components/LoginButton';
import { authenticate } from '../features/login/loginSlice';

const MainWrapper = styled(Paper)(({ theme }) => ({
	border: '1px solid',
	borderColor: theme.palette.grey[300],
	display: 'flex',
	flexDirection: 'column',
	padding: '2rem',
}));
const LinkItem = styled(Link)<{ component: 'Link' }>(({ theme }) => ({
	textDecoration: 'none',
	borderBottom: '1px solid',
	borderColor: theme.palette.grey[400],
	display: 'flex',
	alignItems: 'center',
}));


export default function Debito() {
	const theme = useTheme();
	const [selectedCard, setSelectedCard] = useState(null);
	const [openModal, setOpenModal] = useState(false);
	const [loadingCards, setLoadingCards] = useState(true);
	const [error, setError] = useState(null);
	const { cards } = useSelector((state: RootState) => state.debit);
	const isLogged = useSelector(authed);
	const desktop = useMediaQuery(theme.breakpoints.up('md'));

	const cardData = async () => {
		try {
			setLoadingCards(true);
			const response = await store.dispatch(getCardData());

		} catch (err) {
			// setError('Ocurrió un error inesperado');
		} finally {
			setLoadingCards(false);
		}
	};


	const handleDeleteClick = (card) => {
		setSelectedCard(card);
		setOpenModal(true);
	};

	const handleConfirmDelete = async () => {
		if (selectedCard) {
			const response = await store.dispatch(
				deleteCardData({ imponible: selectedCard.imponible, tipo: selectedCard.tipo_imponible })
			);

			if (deleteCardData.fulfilled.match(response)) {
				setSelectedCard(null);
				setOpenModal(false);
			} else {
				console.error("Error al eliminar la tarjeta:", response.payload);

			}
		}
	};


	const handleCloseModal = () => {
		setSelectedCard(null);
		setOpenModal(false);
	};

	const handleLogin = (provider: string) => {
		store.dispatch(authenticate(provider))
			.unwrap()
			.then(response => {
				window.location.replace(response.url);
			});
	};

	useEffect(() => {
		cardData();
	}, [store.dispatch]);

	return (
		<Page>
			<Container>
				<Grid
					container
					padding={'1.875rem'}
					justifyContent="center"
					direction={desktop ? 'row' : 'column'}
				>
					<Grid item sm={10} sx={{ alignSelf: 'center' }}>
						<Box mb={3}>
							<MainWrapper>
								<Grid container direction="row">
									{isLogged ? <>
										<Grid item md={12} lg={4}>
											<Typography variant="subtitle1" mb="1rem">
												Débito Automático
											</Typography>
											<Typography variant="body1" mb=".5rem">
												A continuación se muestra el listado de tus imponibles adheridos al Débito Automático.
												Desde aquí podés eliminar una adhesión si ya no corresponde.
												Si querés agregar un nuevo imponible, hacé clic en 'Adherir'.
											</Typography>
										</Grid>
									</> :
										<>
											<Grid item md={12} lg={7}>
												<Typography variant="subtitle1" mb="1rem">
													Débito Automático
												</Typography>
												<Typography variant="body1" mb=".5rem">
													Para acceder a las funcionalidades de Débito Automático y realizar el pago de tus facturas de Tasas de Inmuebles, Rodados, Comercios, Contribuyentes y Contribuciones, primero debés iniciar sesión con tu cuenta de ARCA o ANSES.
												</Typography>
												<Typography variant="body1" mb=".5rem">
													A continuación, ingresá tus credenciales en el siguiente formulario.
												</Typography>
											</Grid>
										</>
									}

									{isLogged ?
										<Grid item xs={12} md={12} lg={8}>
											<Box sx={{ border: '1px solid #e4e6ef', borderRadius: '5px', padding: '1.875rem', margin: '0.5rem' }}>
												{cards && (cards.length === 0 ?
													<Typography variant="body1" color="textSecondary">
														No tenés ningún imponible adherido aún al Débito Automático.
													</Typography>
													:
													<>
														<Grid spacing={2} sx={{ gap: '5px' }}>
															{!loadingCards && <>
																{cards && cards.length > 0 ? cards.map((card) => (
																	<Grid item xs={12} key={card.id} sx={{ border: '1px solid #e4e6ef', borderRadius: '5px', padding: '10px', backgroundColor: '#fbfbfb' }} mb="1rem">
																		<Grid sx={{ padding: '10px' }}>
																			<Grid sx={{ display: 'flex', gap: '10px', justifyContent: 'space-between' }} mb="1rem">
																				<Grid sx={{ display: 'flex', flexDirection: 'column' }}>
																					<Typography variant="caption" fontWeight="bold">Imponible</Typography>
																					<Typography variant="body2">{card.imponible}</Typography>
																				</Grid>
																				<Grid sx={{ display: 'flex', flexDirection: 'column' }}>
																					{/* <Typography variant="caption" fontWeight="bold">Medio de adhesión</Typography> */}
																					<Typography variant="body2" sx={{
																						padding: '5px 15px 5px 15px',
																						backgroundColor: '#dcf4fd',
																						borderRadius: '8px',
																						color: '#63a0d5'
																					}}>{card.tipodebito}</Typography>
																				</Grid>
																			</Grid>

																			<Typography variant="caption" fontWeight="bold">
																				{card.nrotarjeta ? 'Número de tarjeta' : 'CBU'}
																			</Typography>
																			<Typography variant="body2" sx={{ fontSize: '1.2rem' }} fontFamily="monospace">
																				{card.nrotarjeta || card.cbu}
																			</Typography>
																		</Grid>
																		<Grid sx={{ display: 'flex', justifyContent: 'end', gap: '10px' }}>

																			<IconButton
																				color="error"
																				sx={{ alignSelf: 'flex-end', marginTop: 'auto' }}
																				onClick={() => handleDeleteClick(card)}
																			>
																				<Delete />
																			</IconButton>
																		</Grid>
																	</Grid>
																)) : <></>}
															</>}

														</Grid>
													</>
												)}
												<Grid sx={{ display: 'flex', justifyContent: 'end' }}>
													<LinkItem component="Link" to="/debito-automatico/medios-pagos" sx={{ border: 'none', marginTop: '10px' }}>
														<Typography
															sx={{
																color: '#fff',
																fontSize: '0.75rem',
																padding: '5px 15px 5px 15px',
																borderRadius: '4px',
																backgroundColor: '#36b7e8'
															}}
														>
															Adherir
														</Typography>
													</LinkItem>
												</Grid>
											</Box>
										</Grid>
										:
										<>
											<Grid item xs={12} md={12} lg={5}>
												<Box sx={{ border: '1px solid #e4e6ef', borderRadius: '5px', padding: '1.875rem', margin: '0.5rem' }}>
													<Grid item xs={12} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
														<Typography variant="h6" mb={'0.5rem'} mt={'0.5rem'}>
															Iniciar Sesión
														</Typography>
													</Grid>

													<Grid item xs={12}>
														<LoginButton title={'ARCA'} handleClick={() => handleLogin('afip')} />
														<LoginButton title={'ANSES'} handleClick={() => handleLogin('anses')} />
													</Grid>
												</Box>
											</Grid>
										</>}

								</Grid>
							</MainWrapper>
						</Box>
					</Grid>
				</Grid>
			</Container>

			<Dialog open={openModal} onClose={handleCloseModal}>
				<DialogTitle>¿Eliminar método de pago?</DialogTitle>
				<DialogContent>
					{selectedCard && (
						<DialogContentText>
							Estás por desvincular el imponible <strong>{selectedCard.imponible}</strong>.
							<br />
							De ({selectedCard.tipodebito}) {selectedCard.nrotarjeta ? `${selectedCard.nrotarjeta}` : `${selectedCard.cbu}`}
						</DialogContentText>
					)}
				</DialogContent>
				<DialogActions>
					<Button onClick={handleCloseModal} color="primary">
						Cancelar
					</Button>
					<Button onClick={handleConfirmDelete} color="error">
						Eliminar
					</Button>
				</DialogActions>
			</Dialog>
		</Page>
	);
}
